module.exports = __webpack_public_path__ + "img/icon_proceso_de_carga.f367a2f9.svg";